import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { DEFAULT_LOCALE, SUPPORTED_LOCALE_CODES } from './constants';
// Import translations
import de from './locales/de';
import en from './locales/en';
import fr from './locales/fr';
import es from './locales/es';
import it from './locales/it';
import pt from './locales/pt';
import nl from './locales/nl';
import pl from './locales/pl';
import cs from './locales/cs';
import ja from './locales/ja';
import ko from './locales/ko';
import zh from './locales/zh';
import ru from './locales/ru';
import uk from './locales/uk';
import no from './locales/no';
import sv from './locales/sv';
import { AQPRO_BY_LANG, aqproEn } from './locales/partials/aqpro';
import { FIRMAMENT_BY_LANG, firmamentEn } from './locales/partials/firmament';
import { RADIOCODE_BY_LANG, radiacodeEn } from './locales/partials/radiacodeapp';
import { VERSION_COMPARE_BY_LANG, versionCompareEn } from './locales/partials/versionCompare';
function withLocaleExtras(base, lang) {
    const pack = VERSION_COMPARE_BY_LANG[lang] || versionCompareEn;
    const paymentBase = base.payment && typeof base.payment === 'object'
        ? base.payment
        : {};
    return {
        ...base,
        aqpro: AQPRO_BY_LANG[lang] || aqproEn,
        firmament: FIRMAMENT_BY_LANG[lang] || firmamentEn,
        radiacodeapp: RADIOCODE_BY_LANG[lang] || radiacodeEn,
        versionExplainer: pack.versionExplainer,
        payment: {
            ...paymentBase,
            twoVersionsTitle: pack.payment.twoVersionsTitle,
            versionSelectHint: pack.payment.versionSelectHint,
        },
    };
}
const resources = {
    de: { translation: withLocaleExtras(de, 'de') },
    en: { translation: withLocaleExtras(en, 'en') },
    fr: { translation: withLocaleExtras(fr, 'fr') },
    es: { translation: withLocaleExtras(es, 'es') },
    it: { translation: withLocaleExtras(it, 'it') },
    pt: { translation: withLocaleExtras(pt, 'pt') },
    nl: { translation: withLocaleExtras(nl, 'nl') },
    pl: { translation: withLocaleExtras(pl, 'pl') },
    cs: { translation: withLocaleExtras(cs, 'cs') },
    ja: { translation: withLocaleExtras(ja, 'ja') },
    ko: { translation: withLocaleExtras(ko, 'ko') },
    zh: { translation: withLocaleExtras(zh, 'zh') },
    ru: { translation: withLocaleExtras(ru, 'ru') },
    uk: { translation: withLocaleExtras(uk, 'uk') },
    no: { translation: withLocaleExtras(no, 'no') },
    sv: { translation: withLocaleExtras(sv, 'sv') }
};
i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
    resources,
    fallbackLng: DEFAULT_LOCALE,
    supportedLngs: [...SUPPORTED_LOCALE_CODES],
    nonExplicitSupportedLngs: true,
    load: 'languageOnly',
    detection: {
        order: ['localStorage', 'navigator'],
        caches: ['localStorage'],
        lookupLocalStorage: 'i18nextLng'
    },
    interpolation: {
        escapeValue: false
    },
    react: {
        useSuspense: false
    }
});
export default i18n;
